import React, { useState, useRef } from "react";
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { detect } from "detect-browser";
import { Filter } from "bad-words";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";
import axios from "axios";
import "../elements/contactSection/_contact-page.scss";

const DPLForm = ({ FrontLogo, Constant, defaultEmail }) => {
  const route = useParams();
  const APP_URL = window.site_url;
  const location = useLocation();
  const currentPath = location.pathname;
  const currentpageName = currentPath.split("/").pop();
  const pageName = currentpageName ? currentpageName : "home";
  const [Pagedata, setPagedata] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const browser = detect();
  const filter = new Filter();
  const googleCaptchaKey = Constant.GOOGLE_CAPTCHA_KEY;
  const inputRef = useRef(null);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      varFirstName: "",
      varEmail: "",
      varReason: "",
      chrInfo: false,
      browserName: browser.name || "",
      osName: browser.os || "",
      type: browser.type || "",
      recapcha: "",
    },
    validationSchema: Yup.object({
      varFirstName: Yup.string()
        .required('Please enter your name.')
        .test('no-url', 'URLs are not allowed.', value => !/https?:\/\/[^\s]+/.test(value))
        .matches(/^[a-zA-Z\'\’\‘\`\-\–\—\_\s]+$/,'Please enter valid input.')
        .test('no-bad-words', 'Inappropriate language not allowed.', value => !filter.isProfane(value))
        .max(60, 'Must be 60 characters or less.'),
      varEmail: Yup.string()
        .required("Please enter your email address.")
        .trim()
        .lowercase()
        .test("email-format", "Please enter valid email.", (value) => !value || /^[_A-Za-z0-9\-\–\—]+(\.[_A-Za-z0-9\-\–\—]+)*@[A-Za-z0-9\-\–\—]+(\.[A-Za-z0-9\-\–\—]+)*(\.[A-Za-z]{2,4})$/.test(value))
        .test("unique-email", "This email address already exists.", async function (value) {
          if (!value) return true;
          try {
            const response = await axios.post(`${APP_URL}/api/getEmail`, { varEmail: value });
            return response.data === 0; // Must be 0 to be valid (email doesn't exist)
          } catch (err) {
            return this.createError({ message: "Unable to validate email." });
          }
        }),
      varReason: Yup.string()
        .required("Please enter reason for removal.")
        .test('no-domain-tld','URLs are not allowed.', value => !value || !/^[a-zA-Z0-9\-\.\:\\]+\.(com|org|net|mil|edu|COM|ORG|NET|MIL|EDU)$/.test(value))
        .test('no-url-scheme','URLs are not allowed.', value => !value || !/(ftp|http|https):\/\/(\w+(:\w+)?@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/i.test(value))
        .test('no-bad-words', 'Inappropriate language not allowed.', value => !filter.isProfane(value))
        .test('no-html', 'Please enter valid input.', value => !/<\/?[^>]+(>|$)/.test(value))
        .matches(/^[A-Za-z\0-9\'\’\‘\`\-\–\—\_\"\”\“\.\,\!\?\$\&\(\)\"\:\%\'\*\#\@\-\_\s]+$/, 'Please enter valid input.')
        .max(500, 'Must be 500 characters or less.'),
      chrInfo: Yup.boolean().oneOf([true], 'Please confirm your authorization.') .required('Please confirm your authorization.'),
      recapcha: Yup.string().required("Please select I'm not a robot."),
    }),
    onSubmit: async (values, { resetForm }) => {
      document.getElementById('submitBtn').disabled = true;
      try {
        await axios.post(`${APP_URL}/api/data-removal`, values);
        resetForm();
        navigate("/thank-you", { state: { message: "We have sent confirmation link to the entered email address. Please check your inbox and confirm you are the original requester.", fromSubmission: true } });
      } catch (error) {
        toast.error("Something went wrong! Please try after some time.");
        console.error("Error submitting form:", error);
        document.getElementById('submitBtn').disabled = false;
      }
    },
  });

  const handleRecaptchaChange = (value) => {
    formik.setFieldValue("recapcha", value);
  };

  return (
    <>
        <style>
          {`
            * {
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
              }

              html,
              body {
                  margin: 0;
                  padding: 0;
                  width: 100%;
              }
            
              body {
                  font-size: 16px;
                  vertical-align: baseline;
                  color: #1A1A1A;
                  padding: 30px 15px;
              }
                   img {
                vertical-align: middle;
            }

             #wrapper{
                overflow:hidden;
              }

            p {
                line-height: 22px;
                margin: 0 0 10px;
            }

            .dpl_container {
                max-width: 1170px;
                padding-right: 15px;
                padding-left: 15px;
                margin-right: auto;
                margin-left: auto;
            }
            .bg-form
            {
                padding: 40px;
                box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
            }
            .dpl-header {
                display: block;
                margin-bottom: 30px;
            }

            .dpl_logo img {
                max-width: 100%;
                max-height: 100%;
            }

            .dpl_logo {
                max-width: 200px;
                background-color: #fff;
                border-radius: 25px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: auto;
            }

            .dpl_title {
                font-size: 28px;
                color: #00205A;
                letter-spacing: 0.5px;
            }

            .dpl_subtitle {
                font-size: 16px;
                color: rgba(0, 0, 0, 0.5);
                margin-top: 5px;
                letter-spacing: 0.5px;
                margin-bottom: 5px;
            }

            .dpl_form_group {
                margin-bottom: 20px;
            }

            .dpl_form_group .dpl_select {
                padding: 5px;
                max-width: 600px;
                width: 100%;
                font-size: 15px;
                height: 40px;
                border-color: #dadada;
            }

            .dpl_form_group select.dpl_select:required:invalid {
                color: gray;
            }

            .dpl_form_group .dpl_label {
                font-size: 16px;
                display: block;
                margin: 0 0 5px;
                color: #000000;
                line-height: 100%;
            }

            .dpl_form_group .dpl_input {
                width: 100%;
                height: 53px;
                border-radius: 6px;
                resize: none;
                padding: 15px 20px;
                font-size: 15px;
                border: 1px solid #dadada;
            }

            .dpl_form_group .dpl_textarea {
                width: 100%;
                padding: 10px;
                border-radius: 6px;
                padding: 15px 20px;
                font-size: 15px;
                border:1px solid #dadada;
            }

            .dpl_form_group .dpl_required {
                color: red;
                display: block;
                font-size: 14px;
                margin-top: 5px;
            }

            .dpl_required_note {
                color: red;
                font-size: 13px;
                line-height: 100%;
                margin-top: 15px;
            }

            .google-captcha {
                margin: 20px 0 30px;
            }

            .dpl_button {
                background-color: #35997c;
                color: #ffffff;
                font-size: 18px;
                padding: 10px 20px;
                border: none;
                border-radius: 30px;
                transition: all 0.5s ease-in-out;
                margin-bottom: 30px;
                height: 50px;
                cursor: pointer;
                letter-spacing: 0.5px;
                padding: 10px 60px;
            }

            .dpl_button:hover {
                background-color: #1c2755;
            }

            .dpl_checkbox_note {
                padding: 15px;
                border: 1px solid #ccc;
                width: 100%;
                margin: 20px 0;
                background: #ffffff;
            }

            .dpl_checkbox {
                padding-left: 30px;
                display: inline-block;
                position: relative;
            }

            .dpl_checkbox input[type=checkbox] {
                position: absolute;
                left: 0;
                width: 15px;
                height: 15px;
                vertical-align: -2px;
            }

            .dpl_note
            {
              font-size: 13px;
              color: #494949;
              line-height: 120%;
            }

            @media(max-width:1024px) {
                .dpl-header {
                    margin-bottom: 30px;
                }

                .dpl_logo {
                    width: 250px;
                    height: 150px;
                }
            }

            @media(max-width:992px) {

                .dpl_form_group .dpl_select,
                .dpl_form_group .dpl_input,
                .dpl_form_group .dpl_textarea,
                .dpl_checkbox_note {
                    max-width: 100%;
                }
                    .dpl_logo img {
                    max-width: 180px;
                }
            }

            @media(max-width:767px) {
                body {
                    font-size: 14px;
                }

                .dpl_logo {
                    width: 200px;
                    height: 130px;
                }

                .dpl_form_group .dpl_input,
                .dpl_form_group .dpl_textarea {
                    width: 100%;
                }

                .dpl_checkbox_note {
                    width: 100%;
                }

                .dpl_form_group .dpl_label {
                    font-size: 14px;
                }

                .dpl_title {
                    font-size: 22px;
                }

                .dpl_subtitle {
                    font-size: 18px;
                }
            }

            .ac-loader .ac-loader__container .loader img {
                max-width: 100px;
            }
            .btn {
              padding: 19px 80px 19px 30px;
              font-size: 16px;
              border: none;
              font-family: "Inter";
              font-weight: 500;
              line-height: 128%;
              letter-spacing: 0px;
              border-radius: 30px;
              box-shadow: none;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              transition: all 0.3s ease-in-out;
              position: relative;
              overflow: hidden;
              box-shadow: none !important;
              text-transform: uppercase;
              letter-spacing: 0.5px;
              background: #FB515E;
              color:white;
          }

          .btn .arrow {
              position: absolute;
              right: 35px;
              transition: all 0.3s ease-in-out;
          }

          .btn .arrow svg {
              width: 20px;
              height: 18px;
          }

          .btn .arrow svg path {
              fill: white;
          }
          @media (max-width: 767px) {
              .btn {
                  padding: 12px 40px 12px 18px;
                  font-size: calc(16px - 2px);
              }
              .btn .arrow {
                  right: 15px;
              }
              .btn .arrow svg {
                  width: 15px;
                  height: 15px;
              }
              .g-captcha
              {
                display:table;
                margin:auto auto 15px;
              }
              .bg-form
              {
                  padding: 30px;
              }
          }
          @media (max-width:575px)
          {
            .g-captcha
            {
                transform: scale(0.9);
                -webkit-transform:scale(0.9);
                transform-origin: left;
                -webkit-transform-origin: left;
            }
          }
          @media (min-width: 1200px) {
            .btn:hover{
            background: #FB515E;
            color:white;
            }
              .btn:hover .arrow {
                  animation: slide1 1s ease-in-out infinite;
              }
          }

              @keyframes slide1 {
                  0%,
                  100% {
                      transform: translate(0, 0);
                  }
                  50% {
                      transform: translate(10px, 0);
                  }
              }
            `}
        </style>
        <div className="dpl-header mt-3 mt-md-5">
          <div className="dpl_container">
            <Link to="/" title={Constant?.SITE_NAME} className="dpl_logo">
              <img src={FrontLogo?.image} alt={Constant?.SITE_NAME} />
            </Link>
          </div>
        </div>
        <div className="dpl_container bg-form">
          <h1 className="dpl_title">Privacy Removal</h1>
          <h4 className="dpl_subtitle">Personal Information Removal Request Form</h4>
          <p>For privacy reasons, you may have the right to reuest certain personal information be removed from our database.</p>
          <div className="mt-5">
            <h4 className="dpl_subtitle">Your Information</h4>
            {/* Form Start */}
            <form onSubmit={formik.handleSubmit} name="myform" id="myform">
              <p className="error text-end">* Denotes Required Inputs</p>
              <div className="row">
                <div className="col-md-6">
                  <div className="dpl_form_group">
                    <label className="dpl_label">Name *</label>
                    <input type="text" className="dpl_input" placeholder="Name" id="varFirstName" name="varFirstName" maxLength="60" onChange={(e) => { const value = e.target.value; if (/^\s+$/.test(value)) { formik.setFieldValue("varFirstName", ""); } else { formik.handleChange(e); } }} onBlur={formik.handleBlur} value={formik.values.varFirstName} />
                    {formik.touched.varFirstName && formik.errors.varFirstName && <div className="error">{formik.errors.varFirstName}</div>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="dpl_form_group">
                    <label className="dpl_label">Email Address *</label>
                    <input type="text" className="dpl_input" placeholder="Email" id="varEmail" name="varEmail" maxLength="70" onChange={(e) => { const value = e.target.value; if (/^\s+$/.test(value)) { formik.setFieldValue("varEmail", ""); } else { formik.handleChange(e); } }} onBlur={formik.handleBlur} value={formik.values.varEmail} />
                    <p className="dpl_note mt-2 mb-0">
                      <b>Note:</b> Please enter the same email address which you have used to communicate with us in past.
                    </p>
                    {formik.touched.varEmail && formik.errors.varEmail && <div className="error">{formik.errors.varEmail}</div>}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="dpl_form_group">
                    <label className="dpl_label">Reason for Removal *</label>
                    <textarea className="dpl_textarea" placeholder="Comments" rows="5" name="varReason" maxLength="500" onChange={(e) => { const value = e.target.value; if (/^\s+$/.test(value)) { formik.setFieldValue("varReason", ""); } else { formik.handleChange(e); } }} onBlur={formik.handleBlur} value={formik.values.varReason} />
                    {formik.touched.varReason && formik.errors.varReason && <div className="error">{formik.errors.varReason}</div>}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="dpl_form_group">
                    <label className="dpl_checkbox">
                    <input type="checkbox" className="" name="chrInfo" onChange={(e) => formik.setFieldValue("chrInfo", e.target.checked)} onBlur={formik.handleBlur} checked={formik.values.chrInfo} />I confirm the information is accurate and I am authorized to submit this request.*
                    </label>
                    {formik.touched.chrInfo && formik.errors.chrInfo && <div className="error">{formik.errors.chrInfo}</div>}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="dpl_checkbox_note">
                    <p>Your personal information saved (with your consent) will be erased permanently from our database. The process may take at least 2 weeks. This may limit or prevent us from providing the products or services you have asked. It may also make it more difficult for us to advise you or suggest appropriate alternatives</p>
                    <p>
                      If you need assistance, contact us on <a href="mailto:v1.netclues@gmail.com"> v1.netclues@gmail.com</a>.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="g-captcha">
                    {googleCaptchaKey && (
                      <ReCAPTCHA
                        sitekey={googleCaptchaKey} // Pass it conditionally when defined
                        onChange={handleRecaptchaChange}
                      />
                    )}
                    {formik.touched.recapcha && formik.errors.recapcha && <div className="error">{formik.errors.recapcha}</div>}
                  </div>
                </div>
                <div className="col-auto align-self-center ms-auto me-auto me-md-0 ms-md-auto">
                  <button type="submit" className="btn btn-primary" title="Submit" id="submitBtn">
                    Submit
                      <svg xmlns="http://www.w3.org/2000/svg" width="17.253" height="13.4" viewBox="0 0 17.253 13.4">
                        <path id="Path_73" data-name="Path 73" d="M1191.633,1924.5h15.327a1.036,1.036,0,0,0,.676-.288.937.937,0,0,0,0-1.351,1.036,1.036,0,0,0-.676-.288h-15.327a1.036,1.036,0,0,0-.676.288.938.938,0,0,0,0,1.351A1.036,1.036,0,0,0,1191.633,1924.5Zm8.9,4.112a.945.945,0,0,0-.273.676.9.9,0,0,0,.288.661.96.96,0,0,0,.676.288,1,1,0,0,0,.661-.273l5.751-5.751a.937.937,0,0,0,0-1.351l-5.751-5.751a1,1,0,0,0-.661-.273.959.959,0,0,0-.676.288.9.9,0,0,0-.288.661.945.945,0,0,0,.273.676l5.075,5.075Z" transform="translate(-1190.67 -1916.84)" fill=""></path>
                      </svg>
                  </button>
                </div>
              </div>
              {/* <button type="submit" className="btn" title="Submit">
                Submit <span><svg xmlns="http://www.w3.org/2000/svg" width="12.687" height="17" viewBox="0 0 12.687 17"><g id="Group_163788" data-name="Group 163788" transform="translate(-44.62 0)"><path id="Path_1002" data-name="Path 1002" d="M56.319,0H54.855V4.953c0,.348-.352.52-.624.083L53.264,3.49,52.3,5.036c-.275.435-.624.265-.624-.083V0H46.766A2.152,2.152,0,0,0,44.62,2.152v12.7A2.152,2.152,0,0,0,46.766,17h9.555a.99.99,0,0,0,.986-.986V.988A.99.99,0,0,0,56.319,0ZM56.5,14.448l-9.323.012a.408.408,0,0,0,0,.814H56.5l0,.75a.165.165,0,0,1-.168.168H46.766a1.329,1.329,0,0,1,0-2.658h9.566a.172.172,0,0,1,.17.17v.744Z" transform="translate(0)" fill="#005064" /></g></svg></span>
              </button> */}
            </form>
            {/* Form End */}
          </div>
        </div>
    </>
  );
};

export default DPLForm;
